import moment from 'moment'
import { toCamelCaseProperties } from '@/utils/fn'
import { WebshopProduct } from '.';
import { getPromotionTypeName} from '@/constants/promotion-types'

export default class WebshopCampaign {
  constructor(args) {
    args = toCamelCaseProperties(args) || {};
    var imageVersion = args.imgUrl.split('/').reverse()[2]
    this.benefitQty = args.benefitQty ? args.benefitQty : null;
    this.benefitRule = args.benefitRule ? args.benefitRule : null;
    this.benefitValue1 = args.benefitValue1 ? args.benefitValue1 : null;
    this.benefitValue2 = args.benefitValue2 ? args.benefitValue2 : null;
    this.campaignAvailableIn = args.campaignAvailableIn;
    this.campaignDateTo = args.campaignDateTo;
    this.campaignDateFrom = args.campaignDateFrom;
    this.campaignId = args.campaignId;
    this.campaignName = args.campaignName;
    this.campaignType = args.campaignType;
    this.chainId = args.chainId;
    this.imageConfig = args.imageConfig ? JSON.parse(args.imageConfig) : {};
    this.imageUrl = imageVersion != null && imageVersion != '' ? parseInt(imageVersion.replace('v', '')) : 0
    this.imgUrl = args.imgUrl;
    this.information = args.information;
    this.productIds = args.productIds;
    this.products = args.products ? args.products.map(p => new WebshopProduct(p)) : null;
    this.promotionType = {
      promotionType: args.campaignPromotionType,
      promotionTypeName: getPromotionTypeName(args.campaignPromotionType)
    };
    this.updatedTime = moment(args.updatedTime).format('DD.MM.YYYY');
    this.totalValue = args.products?.length ?  getTotalValue(args.products) : args.totalValue;
    this.campaignValue = args.products?.length ?  getCampaignValue(args.products) : args.campaignValue;
    this.urlSafeCampaignName = args.urlSafeCampaignName;
    this.additionalValue = parseInt(args.additionalValue) ? args.additionalValue : null;
    this.subscriptions = args.subscriptionList || args.subscriptions.length && typeof args.subscriptions[0] != 'number' ? args.subscriptions : [];
    this.siteIds = args.subscriptions.length && typeof args.subscriptions[0] != 'number' ? args.subscriptions.map(s => s.siteId) : args.subscriptions;
    this.promotionLevel = args.promotionLevel;
    this.dateOfPromotion = args.dateOfPromotion;
    this.maxPerCustomer = args.maxPerCustomer;
    this.stockAmount = args.stockAmount;
    this.subscriptionList = !args.subscriptionList || (args.subscriptions.length && typeof args.subscriptions[0] != 'number') ? args.subscriptions : args.subscriptionList;
  }
}

function getTotalValue(products){
  let value = 0
  products.forEach(p => {
    return value += p.Price
  });

  return value
}

function getCampaignValue(products){
  let value = 0
  products.forEach(p => {
    return value += p.SalesPrice
  });

  return value
}
